import { render, staticRenderFns } from "./BookingListPage.vue?vue&type=template&id=696ba65b&scoped=true"
import script from "./BookingListPage.vue?vue&type=script&lang=js"
export * from "./BookingListPage.vue?vue&type=script&lang=js"
import style0 from "./BookingListPage.vue?vue&type=style&index=0&id=696ba65b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ba65b",
  null
  
)

export default component.exports